import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({
  gfm: true,
  breaks: true,
});

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/**
 * Markdown → безопасный HTML только для завершённых ответов ассистента.
 * Базовая разметка: жирный, курсив, ссылки; списки — как часть GFM.
 */
export function markdownToSafeHtml(markdown) {
  if (!markdown) return "";
  try {
    const raw = marked.parse(markdown, { async: false });
    return DOMPurify.sanitize(raw, {
      ALLOWED_TAGS: [
        "a",
        "b",
        "blockquote",
        "br",
        "em",
        "i",
        "li",
        "ol",
        "p",
        "strong",
        "ul",
      ],
      ALLOWED_ATTR: ["href", "title", "rel", "target"],
    });
  } catch (e) {
    return `<p>${escapeHtml(markdown)}</p>`;
  }
}
